// extracted by mini-css-extract-plugin
export default {"imageContainer":"Profile_imageContainer__+xvq5","companyLogoInfo":"Profile_companyLogoInfo__Wu9aI"};